import './SendActiveMessage.scss';
import { ActiveMessagesConstants } from '../ActiveMessagesConstants';
import { INACTIVE_ATTENDENT, INEXISTENT_ATTENDENT } from '../models/ErrorCodes';
import { isNullOrWhiteSpace } from 'data/string';
import { GROWTH_ACTIVE_MESSAGE_WA_SEND_STEP_ALERT_NON_BOT_ATTENDANT_BUTTON_CLICKED, GROWTH_ACTIVE_MESSAGE_WA_SEND_STEP_ALERT_NOT_ACTIONABLE_BUTTON_CLICKED } from '../../GrowthSegmentEvents';
import { ActiveMessagesFeatures } from '../ActiveMessagesFeatures';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { FeatureToggleClientService } from 'feature-toggle-client';
import { blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostName, messaginghubWebsocketHostNameTenant, activeCampaignMfeSettingsSource, } from 'app.constants';
export class SendActiveMessageController {
    static $inject = ['ModalService', 'application', 'AuthenticationService', 'ActiveMessageService', '$state', 'BlipToastService', 'LoadingService', '$translate', 'AlertService', 'GrowthSegmentService', 'TranslateService', 'AccountService2', 'ApplicationService2', '$rootScope'];
    constructor(ModalService, application, AuthenticationService, ActiveMessageService, $state, BlipToastService, LoadingService, $translate, AlertService, GrowthSegmentService, TranslateService, AccountService2, ApplicationService2, $rootScope) {
        'ngInject';
        this.ModalService = ModalService;
        this.application = application;
        this.AuthenticationService = AuthenticationService;
        this.ActiveMessageService = ActiveMessageService;
        this.$state = $state;
        this.BlipToastService = BlipToastService;
        this.LoadingService = LoadingService;
        this.$translate = $translate;
        this.AlertService = AlertService;
        this.GrowthSegmentService = GrowthSegmentService;
        this.TranslateService = TranslateService;
        this.AccountService2 = AccountService2;
        this.ApplicationService2 = ApplicationService2;
        this.$rootScope = $rootScope;
        this.GO_BACK_TEXT = 'Go Back';
        this.CANCEL_TEXT = 'Cancel';
        this.blipWebsocketHostName = messaginghubWebsocketHostNameTenant;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.blipDomainUrl = blipDomainUrl;
        this.settingsSource = activeCampaignMfeSettingsSource;
        this.isBotRouter = this.application?.template == ActiveMessagesConstants.MASTER;
        this.isBotAiAgent = this.application?.template == ActiveMessagesConstants.AI_AGENT;
        this.pathButtonBack = '/application/detail/growth/activeMessages';
    }
    async $onInit() {
        this.isEnabledActiveCampaignMFE = await ActiveMessagesFeatures.isEnabledActiveCampaignMFE();
        if (this.isEnabledActiveCampaignMFE) {
            await this.LoadActiveCampaignMfe();
        }
        else {
            this.stepsData = [];
            this.currentStep = ActiveMessagesConstants.AUDIENCE_STEP;
        }
    }
    async LoadActiveCampaignMfe() {
        try {
            this.LoadingService.startLoading();
            const me = await this.AccountService2.me();
            const account = await this.ApplicationService2.getAccount();
            const userToken = this.AuthenticationService.token;
            const userEmail = encodeURIComponent(me.email);
            const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
            this.featureFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
            this.language = this.TranslateService.getCurrentLanguage();
            this.ownerIdentity = useDelegation ? `${userEmail}/${this.application.shortName}` : this.application.shortName;
            this.botIdentity = account.identity;
            this.token = useDelegation ? userToken : this.application.accessKey;
            this.authEmail = this.AuthenticationService.email;
            this.blipWebsocketHostName = useDelegation ? blipWebsocketHostName : messaginghubWebsocketHostName;
            this.blipWebsocketHostNameTenant = useDelegation ? blipWebsocketHostNameTenant : messaginghubWebsocketHostNameTenant;
            this.LoadingService.stopLoading();
            this.readyToRender = true;
            this.notificationEmailLanguage = this.AuthenticationService.getAccount()?.culture;
            this.notificationEmail = this.AuthenticationService.getAccount()?.email;
        }
        catch (e) {
            console.error('LoadActiveCampaignMfe', e);
        }
    }
    onEditRedirect($data) {
        const stepperComponent = document.querySelector('bds-stepper');
        stepperComponent.setActiveStep($data);
        this.currentStep = $data;
    }
    audienceCallback($data) {
        this.audienceData = this.getStepData($data, ActiveMessagesConstants.AUDIENCE_STEP);
        this.checkChangedSteps(ActiveMessagesConstants.AUDIENCE_STEP, this.audienceData);
    }
    contentCallback($data) {
        this.contentData = this.getStepData($data, ActiveMessagesConstants.CONTENT_STEP);
        this.checkChangedSteps(ActiveMessagesConstants.CONTENT_STEP, this.contentData);
    }
    responseTargetingCallback($data) {
        this.responseTargetingData = this.getStepData($data, ActiveMessagesConstants.RESPONSE_TARGETING_STEP);
        this.checkChangedSteps(ActiveMessagesConstants.RESPONSE_TARGETING_STEP, this.responseTargetingData);
    }
    getStepData(data, step) {
        return {
            name: data.name,
            value: data.value,
            step: step,
            fileUrl: data.fileUrl,
            fileSummary: data.fileSummary,
            params: data.params,
            campaignType: data.campaignType,
            applicationOrigin: data.applicationOrigin,
        };
    }
    checkChangedSteps(step, stepData) {
        const repeatedValue = this.stepsData.find(s => s.step === step);
        if (repeatedValue) {
            this.stepsData[step] = stepData;
        }
        else {
            this.stepsData.push(stepData);
            this.stepsData.sort((a, b) => parseFloat(a.step) - parseFloat(b.step));
        }
    }
    async handleSteps(step) {
        const stepperComponent = document.querySelector('bds-stepper');
        const activeStep = await stepperComponent.getActiveStep();
        stepperComponent.setActiveStep(activeStep + step);
        this.currentStep = activeStep + step;
        if (step == ActiveMessagesConstants.NEXT_STEP) {
            stepperComponent.setCompletedStep(activeStep);
        }
    }
    async handlePreviousStep() {
        this.handleSteps(ActiveMessagesConstants.PREVIOUS_STEP);
    }
    async handleNextStep() {
        this.handleSteps(ActiveMessagesConstants.NEXT_STEP);
    }
    async sendActiveMessage() {
        let campaignId;
        const dispatchData = this.convertData();
        campaignId = await this.ActiveMessageService.create(dispatchData);
        await this.ActiveMessageService.dispatchCampaign(campaignId);
    }
    convertData() {
        return {
            audience: this.stepsData[0],
            content: this.stepsData[1],
            responseTargeting: this.stepsData[2],
            campaignName: this.campaignName,
            schedule: this.schedule,
            notificationEmail: this.AuthenticationService.getAccount()?.email,
            notificationEmailLanguage: this.AuthenticationService.getAccount()?.culture,
        };
    }
    async getAllCampaigns() {
        const campaigns = await this.ActiveMessageService.getCampaigns();
        return campaigns;
    }
    async finishSteps($data, $schedule, $trackingCreateNewCampaign) {
        let errorMessage = undefined;
        this.LoadingService.startLoading();
        this.campaignName = $data;
        this.schedule = $schedule;
        try {
            await this.sendActiveMessage();
            const stepperComponent = document.querySelector('bds-stepper');
            const activeStep = await stepperComponent.getActiveStep();
            stepperComponent.setCompletedStep(activeStep);
            await this.showSuccessToast();
            this.$state.go('auth.application.detail.growth.activeMessages');
        }
        catch (e) {
            errorMessage = String(e);
            await this.showFailureAlert(e);
        }
        finally {
            const trackingFunction = () => this.addStatusAndErrorMessageToTracking($trackingCreateNewCampaign, errorMessage);
            this.trackUserEvent(trackingFunction);
            this.LoadingService.stopLoading();
        }
    }
    async handleRedirect(step) {
        const stepperComponent = document.querySelector('bds-stepper');
        stepperComponent.setActiveStep(step);
    }
    isGroupHandler(isGroup) {
        this.isWhatsAppGroup = isGroup;
    }
    isAiAgentHandler(isAiAgent) {
        this.isAiAgent = isAiAgent;
        this.$rootScope.$broadcast('$onSelectedAudience');
    }
    async showSuccessToast() {
        if (this.schedule) {
            const scheduleSuccessMessage = await this.$translate('activeMessages.scheduleMessageToastText');
            this.BlipToastService.show('success', {
                msg: scheduleSuccessMessage,
            });
            return;
        }
        const successTitle = await this.$translate('activeMessages.sendMessageToastTextTitle');
        const successMessage = await this.$translate('activeMessages.sendMessageToastTextMessage');
        this.BlipToastService.show('success', {
            title: successTitle,
            msg: successMessage,
        });
    }
    async showFailureAlert(e) {
        const errorCode = this.extractCodeFromError(e);
        this.errorAttendance = undefined;
        if (errorCode == INEXISTENT_ATTENDENT || errorCode == INACTIVE_ATTENDENT) {
            this.showInvalidAttendantAlert(errorCode);
            return;
        }
        await this.showFailiureToast(e);
    }
    extractCodeFromError(e) {
        return String(e).split(':')[1].split('. ')[1];
    }
    async showInvalidAttendantAlert(errorCode) {
        const bodyPath = errorCode == INEXISTENT_ATTENDENT ? 'bodyInexistentAttendant' : 'bodyInactiveAttendant';
        const alertTitle = await this.$translate('activeMessages.alertAttendant.title');
        const alertBody = await this.$translate('activeMessages.alertAttendant.' + bodyPath);
        const confirmButton = await this.$translate('activeMessages.alertAttendant.continueButton');
        const cancelButton = await this.$translate('activeMessages.alertAttendant.returnButton');
        await this.AlertService.show({
            title: alertTitle,
            body: alertBody,
            variant: 'error',
            icon: 'error',
            buttons: {
                cancel: cancelButton,
                confirm: confirmButton,
            },
            callback: {
                cancelButtonAction: () => {
                    this.trackUserEvent(() => this.generateReturnRedirectStepTrack(errorCode, this.CANCEL_TEXT));
                },
                confirmButtonAction: async () => {
                    this.errorAttendance = await this.getErrorText(errorCode);
                    this.trackUserEvent(() => this.generateReturnRedirectStepTrack(errorCode, this.GO_BACK_TEXT));
                    this.onEditRedirect(ActiveMessagesConstants.RESPONSE_TARGETING_STEP);
                },
            },
        });
    }
    trackUserEvent($trackingFunction) {
        const { trackerName, tracker } = $trackingFunction();
        this.GrowthSegmentService.trackEvent(trackerName, tracker);
    }
    generateReturnRedirectStepTrack(errorCode, callerEvent) {
        const trackerName = errorCode == INEXISTENT_ATTENDENT ?
            GROWTH_ACTIVE_MESSAGE_WA_SEND_STEP_ALERT_NON_BOT_ATTENDANT_BUTTON_CLICKED :
            GROWTH_ACTIVE_MESSAGE_WA_SEND_STEP_ALERT_NOT_ACTIONABLE_BUTTON_CLICKED;
        return {
            trackerName, tracker: {
                event: callerEvent,
            },
        };
    }
    async getErrorText(errorCode) {
        return errorCode == INEXISTENT_ATTENDENT ?
            this.$translate('activeMessages.send.responseTargeting.redirect.input.errorInexistentAttendant') :
            this.$translate('activeMessages.send.responseTargeting.redirect.input.errorInactiveAttendant');
    }
    async showFailiureToast(e) {
        const failureTitle = this.schedule != undefined ? await this.$translate('activeMessages.scheduleMessageErrorTitle') : await this.$translate('activeMessages.sendMessageErrorTitle');
        const failureText = this.schedule != undefined ? await this.$translate('activeMessages.scheduleMessageErrorText') : `${await this.$translate('activeMessages.sendMessageErrorText')}${e}`;
        this.BlipToastService.show('danger', {
            title: failureTitle,
            msg: failureText,
        });
    }
    addStatusAndErrorMessageToTracking($trackingCreateNewCampaign, errorMessage) {
        const { trackerName, tracker } = $trackingCreateNewCampaign();
        tracker.status = isNullOrWhiteSpace(errorMessage) ? 'Success' : 'Error';
        tracker.errorMessage = errorMessage;
        return { trackerName, tracker };
    }
    goBack() {
        this.$state.go('auth.application.detail.growth.activeMessages');
        return;
    }
}
SendActiveMessageController.$inject = ['ModalService', 'application', 'AuthenticationService', 'ActiveMessageService', '$state', 'BlipToastService', 'LoadingService', '$translate', 'AlertService', 'GrowthSegmentService', 'TranslateService', 'AccountService2', 'ApplicationService2', '$rootScope'];
